"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sorterHelper = exports.sorter = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _dateParser = _interopRequireDefault(require("./dateParser"));
var _isNullOrUndefined = _interopRequireDefault(require("./isNullOrUndefined"));
// Kullanıcılar bu şekillerde de kullanabilir.

// sorter: (a, b, ...params) =>
//     dateSorter(a.recordtime, b.recordtime, ...params),

// Başka kolona göre sıralanmak istendiğinde kolon bilgisi yok.
// sorter: (a, b) => dateSorter(a.birthdate, b.birthdate),
// sorter: (a, b) => a.recordtime.valueof() - b.recordtime.valueof(),

var nullOrUndefinedComparer = function nullOrUndefinedComparer(a, b, descEmptyFirst) {
  if ((0, _isNullOrUndefined.default)(a) && !(0, _isNullOrUndefined.default)(b)) {
    return descEmptyFirst ? 1 : -1;
  } else if (!(0, _isNullOrUndefined.default)(a) && (0, _isNullOrUndefined.default)(b)) {
    return descEmptyFirst ? -1 : 1;
  } else if ((0, _isNullOrUndefined.default)(a) && (0, _isNullOrUndefined.default)(b)) {
    return 0;
  }
};
var dateSorter = function dateSorter(start, end, sortOrder, sortColumn) {
  var a = start,
    b = end,
    result;
  var _sortColumn$descEmpty = sortColumn.descEmptyFirst,
    descEmptyFirst = _sortColumn$descEmpty === void 0 ? false : _sortColumn$descEmpty;
  if ((0, _typeof2.default)(a) === 'object' && (0, _typeof2.default)(b) === 'object') {
    a = start[sortColumn.dataIndex];
    b = end[sortColumn.dataIndex];
  }
  if ((0, _isNullOrUndefined.default)(a) || (0, _isNullOrUndefined.default)(b)) {
    return nullOrUndefinedComparer(a, b, descEmptyFirst);
  }
  var aMoment = _dateParser.default.parseMomentByColumnType(sortColumn, a);
  var bMoment = _dateParser.default.parseMomentByColumnType(sortColumn, b);
  if (aMoment.isSame(bMoment)) {
    result = 0;
  } else if (aMoment.isBefore(bMoment)) {
    result = -1;
  } else if (aMoment.isAfter(bMoment)) {
    result = 1;
  }
  return result;
};
var stringSorter = function stringSorter(first, second, sortOrder, sortColumn) {
  var a = first,
    b = second;
  var descEmptyFirst = sortColumn.descEmptyFirst;
  if ((0, _typeof2.default)(a) === 'object' && (0, _typeof2.default)(b) === 'object') {
    a = first[sortColumn.dataIndex];
    b = second[sortColumn.dataIndex];
  }
  if ((0, _isNullOrUndefined.default)(a) || (0, _isNullOrUndefined.default)(b)) {
    return nullOrUndefinedComparer(a, b, descEmptyFirst);
  }
  return a.localeCompare(b);
};

// sorter: (a, b, ...params) =>
//     numberSorter(a.name.length, b.name.length, ...params),
var numberSorter = function numberSorter(first, second, sortOrder, sortColumn) {
  var a = first,
    b = second;
  var descEmptyFirst = sortColumn.descEmptyFirst;
  if ((0, _typeof2.default)(a) === 'object' && (0, _typeof2.default)(b) === 'object') {
    a = first[sortColumn.dataIndex];
    b = second[sortColumn.dataIndex];
  }
  if ((0, _isNullOrUndefined.default)(a) || (0, _isNullOrUndefined.default)(b)) {
    return nullOrUndefinedComparer(a, b, descEmptyFirst);
  }
  return a - b;
};
var sorter = exports.sorter = function sorter(_ref) {
  var data = _ref.data,
    key = _ref.key,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'string' : _ref$type,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'asc' : _ref$direction,
    format = _ref.format;
  var sortedData;
  // eslint-disable-next-line default-case
  switch (type) {
    case 'number':
      sortedData = data.sort(function (a, b) {
        return numberSorter(a[key], b[key]);
      });
      break;
    case 'string':
      sortedData = data.sort(function (a, b) {
        return stringSorter(a[key], b[key]);
      });
      break;
    case 'date':
      sortedData = data.sort(function (a, b) {
        return dateSorter(a[key], b[key], null, format);
      });
      break;
  }
  return direction === 'descend' || direction === 'desc' || direction === 'des' ? sortedData.reverse() : sortedData;
};
var sorterHelper = exports.sorterHelper = {
  date: dateSorter,
  string: stringSorter,
  number: numberSorter
};